// Controls
import { DynamicIcon } from "@ms/planner-generic-controls/lib/local/dynamicIcon/DynamicIcon";
// Icons
import { BoardSplit, BoardSplitFilled } from "@ms/planner-generic-controls/lib/local/icons/index";
// Models
import { ContainerType } from "@ms/planner-models/lib/local/service/planner/enumerations/IPlannerEnumerations";
// Styles
import { usePlanIconStyles } from "./PlanIcon.styles";
import { customizeStyles } from "@ms/planner-generic-controls/lib/local/utilities/StyleUtilities";
import React from "react";
/**
 * Control for showing correct icon or photo for a plan
 * Displays a photo for group containers or board split icon for other container types.
 */ export const PlanIcon = (props)=>{
    const { containerPhoto, containerType, focused = false, showIconOnly, name, size = 20, customStyles } = props;
    const defaultStyles = usePlanIconStyles();
    const styles = customizeStyles(defaultStyles, customStyles);
    const icon = focused ? /*#__PURE__*/ React.createElement(BoardSplitFilled, null) : /*#__PURE__*/ React.createElement(BoardSplit, null);
    const imageUrl = !showIconOnly && containerType === ContainerType.Group ? containerPhoto : undefined;
    return /*#__PURE__*/ React.createElement(DynamicIcon, {
        className: styles.dynamicIcon,
        name: name,
        focused: focused,
        imageUrl: imageUrl,
        icon: icon,
        avatarProps: {
            size: size,
            color: imageUrl ? "colorful" : "brand"
        },
        ariaLabel: name
    });
};
